import MarsModule from './MarsModule';

export default MarsModule;
